
import React from 'react';
import './loader.css'

const Loader = ()=>{
    
    
    return( 
    <div className='spinnerOverlay'>
        <div className='SpinnerContainer'>
        </div>
    </div>
    )
}


export default Loader